<!-- STANDARD Modal Header (SuperPrompt V9) -->
<div class="modal-header">
  <h3 class="modal-title">{{title}}</h3>
  <div class="header-actions">
    <i class="fa"
       [ngClass]="{'fa-plus-square-o': minimise, 'fa-minus-square-o': !minimise}"
       style="margin-right: 10px; cursor: pointer;"
       (click)="minimise=!minimise"></i>
    <i (click)="cancel()" class="fa fa-times" style="cursor: pointer;"></i>
  </div>
</div>

<!-- STANDARD Modal Body (SuperPrompt V9) -->
<div class="modal-body" [hidden]="minimise">
  <!-- SMALL loader for form content (SuperPrompt V9) -->
  @if (showFormLoader) {
<div class="formLoader">
    <i class="fa fa-spinner fa-spin gt-refresh"></i>
  </div>
}

  @if (!showFormLoader) {
<div>
    <!-- Entity information table (SuperPrompt V9 - EXISTS in original) -->
    <table class="table table-bordered form-inline enityDetails custom-table">
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span><strong>{{ item.key }}</strong></span>
        </td>
}
      </tr>
      <tr>
        @for (item of entityList; track $index) {
<td>
          <span>{{ item.value }}</span>
        </td>
}
      </tr>
    </table>

    <!-- Name and EIN readonly fields -->
    @if (scheduleFFormView.rows.length > 1) {
<table class="table table-bordered form-inline custom-table">
      <thead>
        <th>{{scheduleFFormView.rows[0].description}}</th>
        <th>{{scheduleFFormView.rows[1].description}}</th>
      </thead>
      <tbody>
        <tr>
          <td>
            <input class="form-control input-md input-text-left"
                   style="width: 100%;"
                   type="text"
                   [(ngModel)]="scheduleFFormView.rows[0].value1"
                   readonly
                   aria-describedby="basic-addon2">
          </td>
          <td>
            <input class="form-control input-md input-text-left"
                   style="width: 100%;"
                   type="text"
                   [(ngModel)]="scheduleFFormView.rows[1].value1"
                   readonly
                   aria-describedby="basic-addon2">
          </td>
        </tr>
      </tbody>
    </table>
}

    <!-- Main form table with Yes/No checkboxes -->
    <table class="table table-bordered form-inline custom-table">
      <thead>
        <tr>
          <th colspan="2"></th>
          <th colspan="1" class="subHeader">
            <span class="schd-ins">Yes</span>
          </th>
          <th colspan="1" class="subHeader">
            <span class="schd-ins">No</span>
          </th>
        </tr>
      </thead>
      <tbody>
        @for (row of scheduleFFormView.rows; track $index; let i = $index) {
<tr [hidden]="i <= 1">
          <td style="width: 58px">{{row.num}}</td>
          <td>{{row.description}}</td>
          <td style="width: 110px" align="right">
            <div>
              <!-- CRITICAL: Mutual exclusive checkbox (SuperPrompt V9 - PUŁAPKA #1) -->
              <input type="checkbox"
                     [(ngModel)]="row.value1"
                     [checked]="row.value1 === true"
                     (change)="unselectOther(i, 'YES')">
            </div>
          </td>
          <td style="width: 110px" align="right">
            <div>
              <!-- CRITICAL: Mutual exclusive checkbox (SuperPrompt V9 - PUŁAPKA #1) -->
              <input type="checkbox"
                     [(ngModel)]="row.value2"
                     [checked]="row.value2 === true"
                     (change)="unselectOther(i, 'NO')">
            </div>
          </td>
        </tr>
}
      </tbody>
    </table>
  </div>
}
</div>

<!-- STANDARD Footer (SuperPrompt V9) -->
<div class="modal-footer" [hidden]="minimise">
  @if (currentTabName != 'Subsidiary') {
<button
          class="save-button"
          type="button"
          [disabled]="isSaveClicked"
          (click)="save()">
    @if (crudLoading) {
<span><i class="fa fa-spinner fa-pulse"></i></span>
}Save
  </button>
}
  @if (currentTabName != 'Subsidiary') {
<button
          class="reset-button"
          type="button"
          (click)="reset()">Reset</button>
}
  <button class="cancel-button"
          type="button"
          (click)="cancel()">Cancel</button>
</div>

